

























import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BorderCard from '@/components/Helper/Card/BorderCard.vue';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';

@Component<CoinInformationCard>({
  components: { BorderCard },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class CoinInformationCard extends Vue {
  currentStaff!: StaffEntity;
}
